import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import FieldsService from "../../services/fieldsService";

// Queries
export const useGetField = (fieldID, queryOptions = {}) => {
  return useQuery(
    ["fields", fieldID],
    () => FieldsService.get(fieldID),
    queryOptions
  );
};

export const useGetFields = (queryOptions = {}) => {
  return useQuery(["fields"], () => FieldsService.index(), queryOptions);
};

// Mutations
export const useUpdateField = (fieldID, mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation((tagParams) => FieldsService.update(fieldID, tagParams), {
    ...mutationOptions,
    onSuccess: (data) => {
      queryClient.setQueryData(["fields", fieldID], data);
      mutationOptions.onSuccess(data);
    },
  });
};

export const useCreateField = (mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation((tagParams) => FieldsService.create(tagParams), {
    ...mutationOptions,
    onSuccess: (data) => {
      queryClient.setQueryData(["fields", data.id], data);
      mutationOptions.onSuccess(data);
    },
  });
};

export const useDeleteField = (fieldID, mutationOptions = {}) => {
  return useMutation(() => FieldsService.delete(fieldID), mutationOptions);
};
